import styled from 'styled-components';
import tw from 'twin.macro';
import { Alert } from '../../components/ui';
import { handoverClock } from '../ServiceGuestPage/serviceJob';

const Track = styled.div`
  ${tw`h-2 w-full overflow-hidden mt-2`}
  border-radius: 999px;
  background: var(--color-bg-secondary);
`;

const Fill = styled.div<{ $percent: number; $over: boolean }>`
  ${tw`h-full`}
  width: ${({ $percent }) => $percent}%;
  background: ${({ $over }) => ($over ? '#dc2626' : 'var(--color-black)')};
`;

/**
 * The handover clock (spec 019 W26, D8, D30): billable minutes so far from
 * `JobTimeline.handoverMinutesSoFar` against the job's `maxBillableMinutes`,
 * with a reminder 30 minutes before the limit and when it is reached.
 */
export function HandoverClock({
  minutesSoFar,
  maxBillableMinutes,
}: {
  minutesSoFar: number | null | undefined;
  maxBillableMinutes: number | null | undefined;
}) {
  const clock = handoverClock(minutesSoFar, maxBillableMinutes);
  if (!clock) return null;
  return (
    <Alert
      tone={clock.tone}
      title={clock.tone === 'error' ? 'Handover limit reached' : 'Handover time'}
      data-testid="handover-clock"
    >
      {clock.text}
      <Track>
        <Fill $percent={clock.percent} $over={clock.tone === 'error'} />
      </Track>
    </Alert>
  );
}
